<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import Home from './components/Home.vue';
    import PdfPreview from './components/PdfPreview.vue';
    import Receiver from './components/Receiver.vue';
 //   import OBSWebSocket from 'obs-websocket-js';
 //   import * as pdfjsLib from 'pdfjs-dist';

//    const obs = new OBSWebSocket;

/*    const routes = [
        { path: "/", components: [Home, PdfPreview] },
        { path: "/receiver", components: [Receiver] },
    ];*/

//    const router = new VueRouter({ routes });

//    new Vue({ router }).$mount("#app");

    export default {
        name: 'app',
        components: {
            Home,
            PdfPreview,
            Receiver
        },
    };


</script>

<style>
    body {
        margin: 0;
    }

    #app {
        font-family: sans-serif;
    }
</style>

